import { render, staticRenderFns } from "./header-title.vue?vue&type=template&id=5b777a0a&scoped=true&"
import script from "./header-title.vue?vue&type=script&lang=js&"
export * from "./header-title.vue?vue&type=script&lang=js&"
import style0 from "./header-title.vue?vue&type=style&index=0&id=5b777a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b777a0a",
  null
  
)

export default component.exports